import React, { ReactElement } from "react";
import MuiSnackbar, { SnackbarProps } from "@mui/material/Snackbar";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = SnackbarProps & {
    handleClose?: () => void;
    autohideOff?: boolean;
};

export const Snackbar = (props: Props): ReactElement => {
    const { handleClose, autohideOff, ...rest } = props;

    const onClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        if (handleClose) {
            handleClose();
        }
    };

    return (
        <MuiSnackbar
            {...rest}
            autoHideDuration={autohideOff ? null : 5000}
            action={
                <IconButton 
                    size="small" 
                    aria-label="close" 
                    color="inherit" 
                    onClick={onClose}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            }
            onClose={onClose}
        />
    );
};
